// Mock data for WiredByApun Portfolio

export const heroData = {
  logo: "WiredByApun",
  tagline: "Design. Code. Swag.",
  subtitle: "Apun banata hai brands jo dikhte hai ekdum swag! 🔥",
  ctaText: "Let's Create Magic"
};

export const aboutData = {
  title: "Apun Ka Story",
  subtitle: "Kaise bana ek simple ladka digital wizard! ✨",
  story: "Bhai, story simple hai - college mein padh raha tha engineering, lekin dil mein tha creative keeda! Shuru kiya logo design se, phir websites banane laga, aur ab? Ab toh pura brand banata hun! From small startups to big YouTubers, sabke saath kaam kiya hai. Mera mantra? Desi swag ke saath modern touch - bilkul filmy style mein!",
  mission: "Mission hai simple - har brand ko uski unique identity dilana. Tu chahiye corporate look ya street-smart vibe, apun sab kar deta hai!",
  stats: [
    { number: "200+", label: "Happy Clients" },
    { number: "500+", label: "Projects Done" },
    { number: "50+", label: "Brands Built" },
    { number: "99%", label: "Client Satisfaction" }
  ]
};

export const servicesData = [
  {
    id: 1,
    title: "Logo Design",
    subtitle: "Desi + Modern Swag",
    description: "Tera brand identity banaunga jo dikhegi ekdum unique! Modern techniques ke saath desi touch - logo jo yaad reh jaaye!",
    price: "₹2,999",
    features: [
      "3 Unique Concepts",
      "Unlimited Revisions",
      "Vector Files (AI, EPS, PNG)",
      "Brand Guidelines",
      "Social Media Kit"
    ],
    icon: "🎨",
    popular: false
  },
  {
    id: 2,
    title: "Website Development",
    subtitle: "Wix | Notion | Framer",
    description: "Website banwana hai? Apun expert hai Wix, Notion aur Framer mein! Modern, responsive aur bilkul trendy!",
    price: "₹8,999",
    features: [
      "Custom Design",
      "Mobile Responsive",
      "SEO Optimized",
      "Contact Forms",
      "Social Integration",
      "1 Month Support"
    ],
    icon: "💻",
    popular: true
  },
  {
    id: 3,
    title: "PR Kit",
    subtitle: "Complete Launch Strategy",
    description: "Brand launch karna hai? PR kit ready karunga - captions, bios, strategies sab kuch! Viral hone ka time aa gaya!",
    price: "₹4,999",
    features: [
      "Instagram Bio & Captions",
      "Launch Strategy",
      "Content Calendar (1 month)",
      "Hashtag Research",
      "Brand Voice Guidelines"
    ],
    icon: "📢",
    popular: false
  },
  {
    id: 4,
    title: "Creative Reels & Videos",
    subtitle: "Branding Videos",
    description: "Video content chahiye jo dikhaye tera brand ka swag? Motion graphics, reels, promotional videos - sab kuch!",
    price: "₹6,999",
    features: [
      "5 Creative Reels",
      "Brand Intro Video",
      "Motion Graphics",
      "Music & Effects",
      "Multiple Formats"
    ],
    icon: "🎬",
    popular: false
  }
];

export const portfolioData = [
  {
    id: 1,
    title: "FoodieKing Restaurant",
    category: "Logo Design",
    description: "Modern Indian restaurant ka complete branding",
    image: "https://images.unsplash.com/photo-1567620905732-2d1ec7ab7445?w=500&q=80",
    tags: ["Logo", "Branding", "Restaurant"]
  },
  {
    id: 2,
    title: "TechBro YouTube Channel",
    category: "Website + PR Kit",
    description: "Tech reviewer ke liye complete digital presence",
    image: "https://images.unsplash.com/photo-1611224923853-80b023f02d71?w=500&q=80",
    tags: ["Website", "YouTube", "Tech"]
  },
  {
    id: 3,
    title: "DesiGym Fitness Brand",
    category: "Complete Branding",
    description: "Fitness brand ka logo, website aur marketing material",
    image: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=500&q=80",
    tags: ["Fitness", "Branding", "Complete"]
  },
  {
    id: 4,
    title: "FashionFunda E-commerce",
    category: "Website Development",
    description: "Fashion e-commerce site with modern UI/UX",
    image: "https://images.unsplash.com/photo-1441984904996-e0b6ba687e04?w=500&q=80",
    tags: ["E-commerce", "Fashion", "Website"]
  },
  {
    id: 5,
    title: "CricketMania App",
    category: "UI/UX Design",
    description: "Cricket enthusiasts ke liye mobile app design",
    image: "https://images.unsplash.com/photo-1540747913346-19e32dc3e97e?w=500&q=80",
    tags: ["App", "Sports", "UI/UX"]
  },
  {
    id: 6,
    title: "MomKitchen Food Delivery",
    category: "Branding + Video",
    description: "Home-cooked food delivery ka complete campaign",
    image: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=500&q=80",
    tags: ["Food", "Delivery", "Campaign"]
  }
];

export const testimonialsData = [
  {
    id: 1,
    name: "Rohit Sharma",
    role: "YouTuber (500K subscribers)",
    comment: "Bhai, WiredByApun ne mera channel ka complete makeover kiya! Logo se lekar thumbnails tak, sab kuch next level! Subscribers bhi badh gaye 50% in just 2 months! 🔥",
    rating: 5,
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&q=80"
  },
  {
    id: 2,
    name: "Priya Patel",
    role: "Startup Founder, TechSolutions",
    comment: "Humara startup ka branding bilkul different level ka hai! Professional yet modern, exactly jo chahiye tha. Client meetings mein logo dekhke hi impress ho jaate hain! Highly recommend! 💯",
    rating: 5,
    avatar: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=100&q=80"
  },
  {
    id: 3,
    name: "Arjun Singh",
    role: "Restaurant Owner, Spice Route",
    comment: "Restaurant ka website aur PR kit banwaya tha. Result? Online orders 3x ho gaye! Design ekdum perfect tha, bilkul wahi vibe jo chahiye thi. Great work!",
    rating: 5,
    avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&q=80"
  },
  {
    id: 4,
    name: "Sneha Gupta",
    role: "Fashion Blogger, StyleDiva",
    comment: "Instagram pe brand identity banwani thi, WiredByApun ne kamaal kar diya! Bio, captions, reels - sab kuch on point! Engagement rate double ho gaya! 🚀",
    rating: 5,
    avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&q=80"
  }
];

export const contactData = {
  title: "Tu Brand Banwa!",
  subtitle: "Ready hai kya apna brand next level pe le jaane ke liye?",
  description: "DM kar fast fast! Consultation free hai, bas tera idea suna aur magic shuru kar dete hain! 🎯",
  whatsapp: "+91 98765 43210",
  email: "hello@wiredbyapun.com",
  instagram: "@wiredbyapun",
  socialLinks: {
    instagram: "https://instagram.com/wiredbyapun",
    whatsapp: "https://wa.me/919876543210",
    email: "mailto:hello@wiredbyapun.com",
    behance: "https://behance.net/wiredbyapun"
  }
};

export const ctaData = {
  title: "Tu Brand Banwa… DM Fast Fast! 🚀",
  subtitle: "Free consultation! Bas ek click aur tera brand journey shuru!",
  buttonText: "Let's Start! 💬",
  urgencyText: "Limited slots available this month!"
};